/**
 * Debug-gated console output.
 * On in dev builds, or in production when localStorage 'sparkconverse_debug' === '1'.
 * Warnings/errors are NOT routed through here - keep using console.warn/console.error.
 */
export function isDebug() {
    if (process.env.NODE_ENV !== 'production')
        return true;
    try {
        return localStorage.getItem('sparkconverse_debug') === '1';
    }
    catch (e) {
        return false;
    }
}
export function dlog(...args) {
    if (isDebug())
        console.log(...args);
}
